import type { ProductBadge } from '@/api'
import { cn } from '@/lib/cn'
import { FireIcon } from '@/components/ui/icons'

const LABELS: Record<ProductBadge, { text: string; className: string; icon: boolean }> = {
  mais_vendido: {
    text: 'MAIS VENDIDO',
    className: 'bg-badge-hot text-white',
    icon: true,
  },
  mais_buscado: {
    text: 'MAIS BUSCADO',
    className: 'bg-ink text-white',
    icon: true,
  },
  oferta_do_dia: {
    text: 'OFERTA DO DIA',
    className: 'bg-accent text-ink',
    icon: false,
  },
}

interface ProductBadgesProps {
  badges: ProductBadge[]
  className?: string
}

export function ProductBadges({ badges, className }: ProductBadgesProps) {
  if (badges.length === 0) return null

  return (
    <div className={cn('flex flex-wrap gap-1.5', className)}>
      {badges.map((badge) => {
        const config = LABELS[badge]
        return (
          <span
            key={badge}
            className={cn(
              'inline-flex items-center gap-1 rounded px-2 py-1 text-[10px] font-bold tracking-wide',
              config.className,
            )}
          >
            {config.icon && <FireIcon className="size-3" />}
            {config.text}
          </span>
        )
      })}
    </div>
  )
}
